import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination,Autoplay } from "swiper/modules";
import { teamData } from "../pages/teamdata";
import "swiper/css";
import "swiper/css/pagination";
import { servicesData } from "../pages/servicesData";
import hero from "../assets/images/hero-bg-video.mp4";
import contactsvg1 from "../assets/images/icon-home-contact-us-1.svg";
import contactsvg2 from "../assets/images/icon-home-contact-us-2.svg";
import contactsvg3 from "../assets/images/icon-home-contact-us-3.svg";
import aboutImg from "../assets/images/about-img.jpg";
import iconExperience from "../assets/images/icon-experience.svg";

/* Import all service images */
import physioImg from "../assets/images/services/physio.jpg";
import osteopathyImg from "../assets/images/services/Osteopathy.jpg";
import acupunctureImg from "../assets/images/services/acupuncture.jpg";
import craniosacralImg from "../assets/images/services/Craniosacral.jpg";
import matrixImg from "../assets/images/services/matrix.jpg";
import chiroImg from "../assets/images/services/Chiropractic.jpg";
import postureImg from "../assets/images/services/posture.jpg";
import neuroImg from "../assets/images/services/neuro.jpg";
import kineticImg from "../assets/images/services/kinetic.jpg";
import somaticsImg from "../assets/images/services/ClinicalSomatics.jpg";
import consciousnessImg from "../assets/images/services/AccessConsciousnessPractices.jpg";
import pelvicImg from "../assets/images/services/pelvic.jpg";

import solutionPlanImg1 from "../assets/images/solution-plan-img-1.jpg";
import solutionPlanImg2 from "../assets/images/solution-plan-img-2.jpg";
import solutionIcon1 from "../assets/images/icon-solution-counter-1.svg";
import solutionIcon2 from "../assets/images/icon-solution-counter-2.svg";
import solutionIcon3 from "../assets/images/icon-solution-counter-3.svg";

import iconwhyus1 from "../assets/images/icon-why-us-1.svg";
import iconwhyus2 from "../assets/images/icon-why-us-2.svg";
import iconwhyus3 from "../assets/images/icon-why-us-3.svg";
import iconwhyus4 from "../assets/images/icon-why-us-4.svg";
import iconwhyus5 from "../assets/images/icon-why-us-5.svg";
import iconwhyus6 from "../assets/images/icon-why-us-6.svg";
import whychooseimg from "../assets/images/why-us-img.png";

import attentionlist1 from "../assets/images/icon-need-attention-1.svg";
import attentionlist2 from "../assets/images/icon-need-attention-2.svg";
import attentionlist3 from "../assets/images/icon-need-attention-3.svg";
import attentionlist4 from "../assets/images/icon-need-attention-4.svg";
import attentionlist5 from "../assets/images/icon-need-attention-5.svg";
import attentionlist6 from "../assets/images/icon-need-attention-6.svg";
import attentionlist7 from "../assets/images/icon-need-attention-7.svg";
import attentionlist8 from "../assets/images/icon-need-attention-8.svg";
import attentionlist9 from "../assets/images/icon-need-attention-9.svg";

import bhargavaImg from "../assets/images/therapist/bhargava.jpeg";
import sruthiImg from "../assets/images/therapist/sruthi.jpeg";

import author1 from "../assets/images/author-1.jpg";
import author2 from "../assets/images/author-2.jpg";
import author3 from "../assets/images/author-3.jpg";
import author4 from "../assets/images/author-4.jpg";

import googlelogo from "../assets/images/google-logo.svg";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const attentionList = [
  { img: attentionlist1, label: "neck pain" },
  { img: attentionlist2, label: "shoulder pain" },
  { img: attentionlist3, label: "hip pain" },
  { img: attentionlist4, label: "knee pain", delay: "0.25s" },
  { img: attentionlist5, label: "elbow pain", delay: "0.25s" },
  { img: attentionlist6, label: "tricep pain", delay: "0.25s" },
  { img: attentionlist7, label: "hand pain", delay: "0.5s" },
  { img: attentionlist8, label: "foot pain", delay: "0.5s" },
  { img: attentionlist9, label: "ankle pain", delay: "0.5s" },
];

const leftItems = [
  {
    img: iconwhyus1,
    title: "Experienced Physiotherapy Team",
    desc: "Our therapists bring years of expertise in pain relief, rehabilitation, and movement correction.",
  },
  {
    img: iconwhyus2,
    title: "Personalized Treatment Plans",
    desc: "Every patient receives a custom plan designed to address the root cause of pain and restore mobility.",
    delay: "0.25s",
  },
  {
    img: iconwhyus3,
    title: "Advanced Clinical Expertise",
    desc: "We specialize in physiotherapy, osteopathy, chiropractic care, sports rehab, and posture correction.",
    delay: "0.5s",
  },
];

const rightItems = [
  {
    img: iconwhyus4,
    title: "Latest Physiotherapy Technology",
    desc: "We use evidence-based methods and advanced equipment for accurate diagnosis and effective treatment.",
  },
  {
    img: iconwhyus5,
    title: "Easy Appointments & Prime Location",
    desc: "Book appointments easily and visit our conveniently located clinic in Hyderabad.",
    delay: "0.25s",
  },
  {
    img: iconwhyus6,
    title: "Active Community Wellness Programs",
    desc: "We conduct workshops on pain prevention, posture correction, and healthy movement habits.",
    delay: "0.5s",
  },
];

/* Service Data (Cleaner & Reusable) */
const serviceList = [
  { img: physioImg, title: "Physiotherapy & Sports Rehab" },
  { img: osteopathyImg, title: "Osteopathy" },
  { img: acupunctureImg, title: "Acupuncture & Dry Needling Therapy" },
  { img: craniosacralImg, title: "Craniosacral Therapy" },
  { img: matrixImg, title: "Matrix Rhythm Therapy" },
  { img: chiroImg, title: "Manual Therapy / Chiropractic Therapy" },
  { img: postureImg, title: "Structural Integration (Posture Correction)" },
  { img: neuroImg, title: "Neuro Kinetic Therapy (NKT)" },
  { img: kineticImg, title: "Kinetic Control Therapy" },
  { img: somaticsImg, title: "Clinical Somatics" },
  { img: consciousnessImg, title: "Access Consciousness Practices" },
  { img: pelvicImg, title: "Pelvic Floor Rehabilitation" },
];
const teamMembers = [
  {
    img: bhargavaImg,
    name: "DR. SKN BHARGAVA",
    role: "MANAGING DIRECTOR",
    role1: "Ortho & Sports Physiotherapist",
    delay: "0s",
    socials: [
      { platform: "instagram", url: "https://www.instagram.com/brightlife_physiopoint/", iconClass: "fab fa-instagram" },
      { platform: "linkedin", url: "http://linkedin.com/in/dr-bhargava-skn-31b96944/", iconClass: "fab fa-linkedin-in" },
    ],
  },
  {
    img: sruthiImg,
    name: "DR. Vishwa Sruthi",
    role: "CEO",
    role1: "Neuro Physiotherapist",
    delay: "0.25s",
    socials: [
      { platform: "instagram", url: "https://www.instagram.com/brightlife_physiopoint/", iconClass: "fab fa-instagram" },
      { platform: "linkedin", url: "https://www.linkedin.com/in/vishwa-sruthi-a181113a5/", iconClass: "fab fa-linkedin-in" },
    ],
  },
];


const truncateText = (text, limit = 120) => {
  if (text.length <= limit) return text;
  return text.slice(0, limit) + "...";
};


const testimonials = [
  {
    rating: 5,
    text: "Very good doctor, who listens patiently to your problems and then suggests the treatment. The place is not like other establishment where they are only behind money. The duo of husband wife are very humble and their staff is also courteous.",
    img: author1,
    name: "Sanjeev Sharma",
  },
  {
    rating: 5,
    text: "I suffered 3 days with intense shoulder pains due to frozen shoulder (2 year issue) while on a business trip in HYD. A colleague recommended Dr. Bhargava's clinic. Dr. Bhargava is truly awesome and amazing. He took the time to review my issue, explain things and propose a treatment. To my amazement his treatment fixed the excruciating pain I had. I was shocked at the relief. I went back one more time for another session. I am now back home and no pain. I wish I was closer to HYD to see Dr. Bhargava if needed. Thank you so much Dr. Bhargava and Dr. Shruti and the entire clinic staff - you are truly amazing.",
    img: author2,
    name: "Corrado Franzo",
  },
  {
    rating: 5,
    text: "Amazing team and amazing session, proved once again that huge and expensive machines are worthless in front of their hands, knowledge and skills. Kudos to the junior and senior physio there, and surely my hyderabad patients are surely going to get physiotherapy from your centre",
    img: author3,
    name: "Dr.Pranjal Jain",
  },
  {
    rating: 5,
    text: "I went for physiotherapy after neck surgery. Dr. Bhargav assured that the problem is due to tightness and will be relieved. My experience is wonderful. The therapists are efficient and cordial. Dr Shruti and Dr. Bhargav takes personal care and believes in cure rather than economic aspects. I like the way therapists enquire about progress every time I went for sessions.",
    img: author4,
    name: "sarma veluri",
  },
];

export default function Home() {
  const [expandedReview, setExpandedReview] = React.useState(null);
  

  return (
    
    <div>
      <Helmet>
  <title>Best Physiotherapy & Sports Rehab in Hyderabad | BrightLife Physio Point</title>
  <meta
    name="description"
    content="BrightLife Physio Point offers expert physiotherapy, sports rehabilitation, chiropractic care & pain management in Hyderabad."
  />
  <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "MedicalBusiness",
  "name": "BrightLife Physio Point",
  "telephone": "+91-9000666889",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Hyderabad",
    "addressRegion": "Telangana",
    "addressCountry": "IN"
  },
  "url": "https://brightlifephysio.com"
}
`}
</script>

</Helmet>
      <div className="hero bg-image hero-video">
        <div className="hero-bg-video">
          <video autoPlay muted loop id="myVideo">
            <source src={hero} type="video/mp4" />
          </video>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="hero-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">
                    Welcome to Brightlife Physio Point
                  </h3>
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    <span>Integrated Pain Management</span> &amp; Sports Rehab
                    Studio
                  </h1>
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    Your journey to recovery starts here.
                  </p>
                </div>

                <div
                  className="hero-content-body wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                   <a
                    href="https://wa.me/919000666889?text=Hi."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-default mobile-cta"
                  >
                    {" "}
                    <i className="fab fa-whatsapp"></i> Whatsapp
                  </a>
                  <a href="https://www.youtube.com/@BrightLifePhysioPoint" target="_blank" className="btn-default">
                    <i className="fab fa-youtube"></i> Youtube
                  </a>
                  <a href="https://www.instagram.com/brightlife_physiopoint/" target="_blank" className="btn-default">
                    <i className="fab fa-instagram"></i> Instagram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="home-contact-us">
        <div class="container">
          <div class="row">
            <div className="col-lg-4 col-md-6">
              <div className="home-contact-item wow fadeInUp">
                <div className="icon-box">
                  <img loading="lazy" src={contactsvg1} alt="" />
                </div>
                <div className="home-contact-content">
                  <h3>Expert Therapists</h3>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div
                className="home-contact-item wow fadeInUp"
                data-wow-delay="0.25s"
              >
                <div className="icon-box">
                  <img loading="lazy" src={contactsvg2} alt="" />
                </div>
                <div className="home-contact-content">
                  <h3>On Demand Home Visit</h3>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div
                className="home-contact-item wow fadeInUp"
                data-wow-delay="0.5s"
              >
                <div className="icon-box">
                  <img loading="lazy" src={contactsvg3} alt="" />
                </div>
                <div className="home-contact-content">
                  <h3>Book Appointments</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-us-image">
                <div className="about-img">
                  <div className=" image-anime">
                    <img loading="lazy" src={aboutImg} alt="aboutimage" />
                  </div>

                  <div className="company-experience">
                    <div className="icon-box">
                      <img loading="lazy" src={iconExperience} alt="experience icon" />
                    </div>
                    <div className="company-experience-content">
                      <h3>
                        <span className="counter">15</span>+
                      </h3>
                      <p>years of experience</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">about us</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    {" "}
                    <span>Brightlife Physio Point</span>
                  </h2>

                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    At Brightlife Physio Point, we believe healing goes beyond
                    treating symptoms—it's about restoring natural movement,
                    strength, and confidence. We offer a blend of advanced
                    physiotherapy techniques and holistic therapies to provide
                    complete, personalized care for every individual.
                  </p>
                  <p className="wow fadeInUp" data-wow-delay="0.5s">
                    With over 15 years of clinical experience, our skilled team
                    focuses on accurate assessment, hands-on treatment, and
                    evidence-based rehabilitation to help you recover faster and
                    live pain-free. From musculoskeletal issues and sports
                    injuries to chronic pain and posture correction, every
                    treatment plan is tailored to your unique needs.
                  </p>
                  <p className="wow fadeInUp" data-wow-delay="0.75s">
                    Our specialized services include Physiotherapy, Osteopathy,
                    Chiropractic Care, Neuro Kinetic Therapy (NKT), Anatomy
                    Trains & Structural Integration, Acupuncture & Dry Needling,
                    Craniosacral Therapy, and Matrix Rhythm Therapy. Whether you
                    are an athlete aiming for top performance or someone seeking
                    long-term relief, we guide your healing journey with
                    expertise and compassion.
                  </p>
                  <p className="wow fadeInUp" data-wow-delay="1s">
                    At Brightlife, your health, mobility, and overall well-being
                    are our top priority.
                  </p>
                </div>

                <div className="about-us-footer">
                  <div
                    className="appointment-btn wow fadeInUp"
                    data-wow-delay="1s"
                  >
                      <a
                    href="https://wa.me/919000666889?text=Hi%20BrightLife%20Physio%20Point,%20I%20would%20like%20to%20book%20an%20appointment."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-default mobile-cta"
                  >
                    {" "}
                      Make an appointment
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="our-service">
        <div className="container">
          {/* SECTION HEADER */}
          <div className="row align-items-center section-row">
            <div className="col-lg-7">
              <div className="section-title">
                <h3 className="wow fadeInUp">Our Services</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  <span>We Provide</span> The Best Services
                </h2>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="section-btn wow fadeInUp" data-wow-delay="0.25s">
                <Link to="/services" className="btn-default">
                  View All Services
                </Link>
              </div>
            </div>
          </div>

          {/* SERVICES GRID */}
          <div className="row">
             {servicesData.map((s, idx) => (
                          <div className="col-lg-4 col-md-6" key={s.id}>
                            <div className="blog-item wow fadeInUp" data-wow-delay={`${0.05 * idx}s`}>
                              <div className="post-featured-image" data-cursor-text="View">
                                <figure>
                                  <Link to={`/services/${s.id}`} className="image-anime">
                                    <img loading="lazy" src={s.img} alt={s.title} />
                                  </Link>
                                </figure>
                              </div>
            
                              <div className="post-item-content">
                                <div className="post-item-body">
                                  <h2>
                                    <Link to={`/services/${s.id}`}>{s.title}</Link>
                                  </h2>
                                  {/* <p>{s.excerpt}</p> */}
                                </div>
                                {/* <div className="post-item-footer">
                                  <Link to={`/services/${s.id}`} className="btn-default">
                                    Read More
                                  </Link>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        ))}
          </div>
        </div>
      </div>

      <div class="solution-your-plan">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="solution-plan-image">
                <div class="solution-plan-img-1">
                  <figure class="image-anime ">
                    <img loading="lazy" src={solutionPlanImg1} alt="" />
                  </figure>
                </div>

                <div class="solution-plan-img-2">
                  <figure class="image-anime ">
                    <img loading="lazy" src={solutionPlanImg2} alt="" />
                  </figure>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="solution-plan-content">
                <div class="section-title">
                  <h3 class="wow fadeInUp">solution to your plan</h3>
                  <h2 class="text-anime-style-2" data-cursor="-opaque">
                    {" "}
                    <span>How Are We</span> Special?
                  </h2>
                  <p class="wow fadeInUp" data-wow-delay="0.25s">
                  At our studio, care goes beyond pain relief — it is a journey toward optimal movement, balance, and lasting well-being.

                  </p>
                  <p>
                    
We specialize in identifying the true root cause and key lesion behind your discomfort, rather than merely addressing surface symptoms. Through detailed assessment of posture, movement patterns, and muscular balance, we uncover the hidden contributors to pain and dysfunction.
                  </p>
                     <p>
                  By seamlessly integrating clinical expertise with holistic therapies, we restore harmony to the body and support complete, long-term recovery.
                </p>
                <p>
                  Every session is personalized, every detail is intentional, and every client receives focused, one-to-one care in a calm, professional environment designed for healing and renewal.
                </p>
                <p>
                  Our mission is not just to help you feel better — but to help you move with confidence, strength, and elegance for life.
                </p>
                </div>
                <h5>Our signature approach blends:</h5>
                <div
                  class="solution-plan-body wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  <ul>
                    <li>
                     Precision posture and movement correction
                    </li>
                    <li>
                       Advanced muscle balancing and functional therapy
                    </li>
                    <li>
                       Elite sports physiotherapy and rehabilitation
                    </li>
                    <li>
                       Holistic healing through Osteopathy and Acupuncture
                    </li>
                  </ul>
                </div>
             
                <div class="solution-plan-counter">
                  <div class="row">
                    <div class="col-lg-4 col-md-4">
                      <div class="solution-counter-item">
                        <div class="icon-box">
                          <img loading="lazy" src={solutionIcon1} alt="" />
                        </div>

                        <div class="solution-counter-content">
                          <h3>
                            <span class="counter">10</span>+
                          </h3>
                          <p>Skilled Therapists</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4">
                      <div class="solution-counter-item">
                        <div class="icon-box">
                          <img loading="lazy" src={solutionIcon2} alt="" />
                        </div>

                        <div class="solution-counter-content">
                          <h3>
                            <span class="counter">98</span>%
                          </h3>
                          <p>Success Rate</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4">
                      <div class="solution-counter-item">
                        <div class="icon-box">
                          <img loading="lazy" src={solutionIcon3} alt="" />
                        </div>

                        <div class="solution-counter-content">
                          <h3>
                            <span class="counter">25000</span>+
                          </h3>
                          <p>Patients Treated</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="why-choose-us">
        <div className="container">
          <div className="row section-row">
            <div className="section-title">
              <h3 className="wow fadeInUp">why us</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">
                <span>What Makes Us </span> Your Trusted Healing Partner
              </h2>
            </div>
          </div>

          <div className="why-choose-us-box">
            <div className="row no-gutters align-items-center">
              {/* LEFT SIDE */}
              <div className="col-lg-6">
                <div className="why-choose-box-1">
                  {leftItems.map((item, index) => (
                    <div
                      className="why-choose-item wow fadeInUp"
                      data-wow-delay={item.delay || "0s"}
                      key={index}
                    >
                      <div className="icon-box">
                        <img loading="lazy" src={item.img} alt={item.title} />
                      </div>

                      <div className="why-choose-content">
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT SIDE */}
              <div className="col-lg-6">
                <div className="why-choose-box-2">
                  {rightItems.map((item, index) => (
                    <div
                      className="why-choose-item wow fadeInUp"
                      data-wow-delay={item.delay || "0s"}
                      key={index}
                    >
                      <div className="icon-box">
                        <img loading="lazy" src={item.img} alt={item.title} />
                      </div>

                      <div className="why-choose-content">
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* BIG IMAGE */}
              <div className="col-lg-12">
                <div className="why-choose-image">
                  <img loading="lazy" src={whychooseimg} alt="Why choose us" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="need-attention parallaxie">
        <div className="container">
          <div className="row section-row">
            <div className="section-title">
              <h3 className="wow fadeInUp">need attention</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">
                Where Do You Need Attention?
              </h2>
              <p className="wow fadeInUp" data-wow-delay="0.25s">
                We understand that injuries and acute pain can happen
                unexpectedly. Our emergency physiotherapy services are designed
                to provide prompt and effective care to help you manage.
              </p>
            </div>
          </div>

          <div className="row">
            {attentionList.map((item, index) => (
              <div className="col-lg-4 col-md-4 col-6" key={index}>
                <div
                  className="need-attention-list wow fadeInUp"
                  data-wow-delay={item.delay || "0s"}
                >
                  <div className="icon-box">
                    <img loading="lazy" src={item.img} alt={item.label} />
                  </div>
                  <div className="need-attention-content">
                    <p>{item.label}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="our-team">
        <div className="container">
          <div className="row align-items-center section-row">
            <div className="col-lg-9">
              <div className="section-title">
                <h3 className="wow fadeInUp">theraphist team</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  <span>Our Dedicated</span> &amp; Experienced Therapist Team
                </h2>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="section-btn wow fadeInUp" data-wow-delay="0.25s">
                <Link to="/therapists" className="btn-default">
                 View All Therapists
                </Link>
              </div>
            </div>
          </div>

          <div className="team-wrapper">
            {/* LEFT: Team Members */}
            <div className="team-left">
              {teamMembers.map((member, index) => (
                <div
                  className="team-member-item wow fadeInUp"
                  data-wow-delay={member.delay}
                  key={index}
                >
                  <div className="team-image">
                    <figure className="image-anime">
                      <img loading="lazy" src={member.img} alt={member.name} />
                    </figure>
                    {/* Socials */}
                    <div className="team-social-icon">
                      <ul>
                        {member.socials.map((s, idx) => (
                          <li key={idx}>
                            <a
                              href={s.url} target="_blank"
                              className="social-icon"
                              aria-label={s.platform}
                            >
                              <i className={s.iconClass} />
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="team-content">
                    <h3>{member.name}</h3>
                    <p>{member.role}</p>
                    <p>{member.role1}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* RIGHT: Info Block */}
            <div className="team-right">
              <h3 className="right-title">Why Choose Our Team?</h3>
              <p className="right-text">
                Our therapists bring over{" "}
                <strong>15+ years of combined experience</strong> in
                Physiotherapy, Sports Rehab, Osteopathy &amp; Advanced Manual
                Techniques.
              </p>

              <ul className="right-list">
                <li>✔ Internationally certified specialists</li>
                <li>✔ Evidence-based treatment approach</li>
                <li>✔ Personalized recovery programs</li>
                <li>✔ 1000+ patients successfully treated</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="our-testimonial parallaxie">
        <div className="container">
          <div className="row section-row">
            <div className="col-lg-12">
              <div className="section-title">
                <h3 className="wow fadeInUp">review</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  <span>What</span> Our Client Say
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div
                className="google-review-badge wow fadeInUp"
                data-wow-delay="0.25s"
              >
                <div className="google-badge-left">
                  <img loading="lazy" src={googlelogo} alt="Google" />
                  <span className="google-rating">4.9</span>
                  <div className="google-stars">★★★★★</div>
                </div>

                <div className="google-badge-right">
                  <span>Based on</span>
                  <strong>100+ Google Reviews</strong>
                </div>
              </div>
              <div className="testimonial-slider">
                <Swiper
                  modules={[Pagination]}
                  pagination={{ clickable: true }}
                  spaceBetween={30}
                  autoplay={{
                    delay: 3000, // 3 seconds per slide
                    disableOnInteraction: false, // continues autoplay after dragging
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1, // mobile
                    },
                    768: {
                      slidesPerView: 2, // tablets (optional)
                    },
                    1200: {
                      slidesPerView: 3, // desktop
                    },
                  }}
                >
                  {testimonials.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-item">
                        <div className="testimonial-header">
                          <div className="testimonial-rating">
                            {Array.from({ length: item.rating }).map((_, i) => (
                              <i key={i} className="fa-solid fa-star"></i>
                            ))}
                          </div>
                          <div className="testimonial-content">
                           <p>
  {expandedReview === index
    ? item.text
    : truncateText(item.text, 100)}

  {item.text.length > 100 && (
    <span
      className="read-more"
      onClick={() =>
        setExpandedReview(
          expandedReview === index ? null : index
        )
      }
    >
      {expandedReview === index ? " Read less" : " Read more"}
    </span>
  )}
</p>

                          </div>
                        </div>

                        <div className="testimonial-body">
                         
                          <div className="author-content">
                            <h3>{item.name}</h3>
                            <p>{item.role}</p>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

